import _, { parseInt } from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import SupportTeamPaginatedGql from '@/extensions/tickets/store/graphql/queries/SupportTeamPaginated.gql';
import TeamMemberDetailGql from '@/extensions/tickets/store/graphql/queries/TeamMemberDetail.gql';
import SearchCmsGql from '@/extensions/tickets/store/graphql/queries/SearchCms.gql';
import SavePlatformTeamMemberGql from '@/extensions/tickets/store/graphql/mutations/SavePlatformTeamMember.gql';
import SearchUsersGql from '@/extensions/tickets/store/graphql/queries/SearchUsers.gql';
import PlatformRightsHistoryGql from '@/extensions/tickets/store/graphql/queries/PlatformRightsHistory.gql';

export default {
    /**
     * One page of the desk's team, with what each person booked in the span.
     * The span is required: every figure on the row is read for it.
     */
    fetchPaginated: (state, { desk, cmsId, from, to }) =>
        new Promise((resolve, reject) => {
            const filters = [];
            _.each(state.filters, (entry) => filters.push(entry));

            apolloClient
                .query({
                    query: SupportTeamPaginatedGql,
                    fetchPolicy: 'network-only',
                    variables: {
                        desk: desk || undefined,
                        cms_id: cmsId ? parseInt(cmsId) : undefined,
                        from,
                        to,
                        currentPage: _.get(state, 'pageInfo.currentPage', 1),
                        perPage: _.get(state, 'pageInfo.perPage', 25),
                        order: _.get(state, 'variables.order', 'logged_time'),
                        direction: _.get(state, 'variables.direction', 'desc'),
                        filters,
                    },
                })
                .then(({ data }) => resolve(data.EX_TCKT_SupportTeamPaginated))
                .catch((err) => reject(err));
        }),

    fetchDetail: ({ userId, from, to, desk, cmsId }) =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: TeamMemberDetailGql,
                    fetchPolicy: 'network-only',
                    variables: {
                        user_id: parseInt(userId),
                        from,
                        to,
                        desk: desk || undefined,
                        cms_id: cmsId ? parseInt(cmsId) : undefined,
                    },
                })
                .then(({ data }) => resolve(data.EX_TCKT_TeamMemberDetail))
                .catch((err) => reject(err));
        }),

    /**
     * One right across many websites in ONE call. The ids travel as a list on
     * purpose: forty requests would be forty chances to half-apply a change.
     */
    // The ticket area's own customer search, reused rather than rebuilt.
    searchWebsites: (term) =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SearchCmsGql,
                    variables: { filters: [{ key: 'name', like: term }] },
                    fetchPolicy: 'network-only',
                })
                .then(({ data }) => resolve(_.get(data, 'CP_CMSsPaginated.items') || []))
                .catch((err) => reject(err));
        }),

    // The whole platform team form in ONE call: rights, the confinement and
    // the website table travel together or not at all.
    savePlatformTeamMember: ({ userId, member }) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SavePlatformTeamMemberGql,
                    variables: { user_id: parseInt(userId), member },
                })
                .then(({ data }) => resolve(data.SavePlatformTeamMember))
                .catch((error) => reject(error));
        }),

    // Who gave this person which right, newest first, a page at a time.
    fetchPlatformRightsHistory: ({ userId, skip, take }) =>
        apolloClient
            .query({
                query: PlatformRightsHistoryGql,
                variables: { user_id: parseInt(userId), skip, take },
                fetchPolicy: 'network-only',
            })
            .then(({ data }) => data.PlatformRightsHistory || []),

    // Anybody who is not on the platform team yet, so they can be put on it.
    searchSuperUserCandidates: (term) =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SearchUsersGql,
                    variables: { filters: [{ key: 'name', like: term }] },
                    fetchPolicy: 'network-only',
                })
                .then(({ data }) => resolve(
                    (_.get(data, 'UsersPaginated.items') || []).filter((item) => !item.super_user)
                ))
                .catch((err) => reject(err));
        }),

};
